<template>
  <div>
    <div class="d-flex align-center justify-center">
      <page-header class="py-4 pb-6">
        {{ $t('DynamicManage') }}
        <template #subtitle>
          {{ $t('ManageStoresUpdates') }}
        </template>
      </page-header>
      <v-spacer />
      <v-btn
        class="amber lighten-4"
        outlined
        @click="activityPostDialog = true"
      >
        {{ $t('PublishNewMessages') }}
      </v-btn>
    </div>
    <loading-provider
      :loading="loading"
    >
      <div>
        <v-card
          v-for="item in allActivityList"
          :key="item.id"
          class="pa-4 mb-4"
          outlined
          width="100%"
          @click="editActivity(item)"
        >
          <div class="d-flex">
            <div class="d-flex flex-column">
              <div
                class="text-body-1"
                style="white-space: pre-line"
              >
                {{ item.title }}
              </div>
              <div
                class="text-body-2"
                style="white-space: pre-line"
              >
                {{ item.outsideUrl }}
              </div>
              <div
                class="text-body-2"
                style="white-space: pre-line"
              >
                {{ item.postContentMd }}
              </div>
              <div class="d-flex">
                <v-card
                  v-for="(url,index) in item.images"
                  :key="index"
                  class="d-flex"
                  elevation="0"
                  outlined
                  style="position: relative;margin-left: 0px"
                >
                  <div style="width: 100%">
                    <img-with-loading
                      :height="'40px'"
                      :img-src="url"
                      :width="'40px'"
                    />
                  </div>
                </v-card>
              </div>
            </div>
          </div>
          <div class="d-flex text-body-2 mt-2">
            <div class="d-flex flex-column">
              <div v-if="item.visibleAt">
                @{{ item.visibleAt | beautifulTime }}
              </div>
              <div
                class="d-flex align-center"
                @click.stop="showLikeList"
              >
                <v-icon color="red">
                  mdi-cards-heart
                </v-icon>
                <div class="text-body-1 font-weight-bold ml-4">
                  {{ item.likeCount }}
                </div>
              </div>
            </div>
            <v-spacer />
            <div>
              <v-icon
                v-if="item.active"
                color="green"
                @click.stop="changActiveStatus(item)"
              >
                mdi-check-decagram-outline
              </v-icon>
              <v-icon
                v-else
                color="red"
                @click.stop="changActiveStatus(item)"
              >
                mdi-close-octagon-outline
              </v-icon>
              <!--              <v-icon-->
              <!--                @click.stop="deleteActivity(item)"-->
              <!--              >-->
              <!--                mdi-delete-->
              <!--              </v-icon>-->
            </div>
          </div>
        </v-card>
      </div>
    </loading-provider>
    <v-dialog
      v-model="activityPostDialog"
      max-width="600px"
    >
      <v-card class="pa-4 ">
        <div class="d-flex align-center">
          {{ $t('Dynamic') }}
          <v-spacer />
          <v-btn
            icon
            @click="activityPostDialog = false"
          >
            <v-icon large>
              mdi-close
            </v-icon>
          </v-btn>
        </div>

        <div>
          <div class="d-flex my-4">
            <v-card
              color="grey lighten-4"
              elevation="0"
              height="72"
              width="72"
              @click.stop="$refs.file.$refs.input.click()"
            >
              <v-icon
                class=" lighten-4 rounded-lg"
                style="position: absolute;right: 0;bottom: 0;top: 0;left: 0;margin: auto"
                x-large
              >
                mdi-plus
              </v-icon>
            </v-card>
            <div class="d-flex">
              <v-card
                v-for="(url,index) in uploadUrls"
                :key="index"
                class="d-flex align-center justify-center"
                elevation="0"
                height="72"
                outlined
                width="72"
              >
                <div style="width: 100%">
                  <img-with-loading
                    :height="'72px'"
                    :img-src="url"
                    :width="'72px'"
                  />
                  <v-btn
                    absolute
                    bottom
                    color="primary"
                    fab
                    icon
                    style="right: -12px"
                    x-small
                    @click.stop="deletePic(index)"
                  >
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </div>
          </div>

          <v-file-input
            ref="file"
            v-model="filesStore"
            accept="image/*"
            dense
            hide-details
            multiple
            outlined
            prepend-icon=""
            style="height: 0;opacity: 0"
          />
          <div>
            <v-text-field
              v-model="title"
              dense
              label="Title"
              outlined
            />
          </div>
          <div>
            <v-text-field
              v-model="outsideUrl"
              dense
              label="outsideUrl"
              outlined
            />
          </div>
          <div>
            <v-select
              v-model="voucherTypeId"
              :items="voucherTypesList"
              dense
              item-text="name"
              item-value="id"
              label="voucherTypeId"
              outlined
            />
          </div>
          <div>
            <date-selector v-model="visibleAt" />
          </div>
          <div>
            <v-textarea
              v-model="postContentMd"
              :placeholder="$t('WriteNewMessages')"
              auto-grow
              hide-details
              outlined
            />
          </div>

          <v-btn
            :loading="btnLoading"
            block
            class="amber lighten-4 mt-4"
            outlined
            @click="createNewPost"
          >
            {{ $t('Publish') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import PageHeader from '@/views/widget/typography/PageHeader'
import LoadingProvider from '@/views/widget/LoadingProvider'
import { showSuccessMessage } from '@/model/utils/utils'
import BLPost from '@/model/dataLayer/api/Vip/BLPost'
import ImgWithLoading from '@/plugins/EntityFrameWork/Base/ImgWithLoading.vue'
import { getVoucherTypesList } from '@/model/dataLayer/api/Vip/VoucherTypes'
import DateSelector from '@/views/AadenPages/settings/reserveSetting/openTime/DateSelector.vue'
import imageCompression from 'browser-image-compression'
import { saveFilesWithArr } from '@/model/dataLayer/api/newReservation/reservationTable'

export default {
  name: 'ActivityPost',
  components: {
    DateSelector,
    ImgWithLoading,
    LoadingProvider,
    PageHeader
  },
  data () {
    return {
      filesStore: null,
      voucherTypesList: [{ name: '不使用优惠券', value: null }],
      images: [],
      title: '',
      outsideUrl: '',
      postContentMd: '',
      voucherTypeId: null,
      visibleAt: null,
      blId: '',
      editObj: null,
      btnLoading: false,
      loading: false,
      editId: -1,
      usePic: [],
      activityPostDialog: false,
      allActivityList: []
    }
  },
  computed: {
    uploadUrls: function () {
      const arr = []
      for (const item of this.usePic) {
        if (typeof item !== 'string') {
          arr.push(URL.createObjectURL(item))
        } else {
          arr.push(item)
        }
      }
      return arr
    }
  },
  watch: {
    async filesStore (val) {
      const options = {
        maxSizeMB: 1,
        useWebWorker: true
      }
      const files = []
      for (const file of val) {
        if (typeof file !== 'string') {
          files.push(await imageCompression(file, options))
        } else {
          files.push(file)
        }
      }
      this.usePic = this.usePic.concat(files)
    },
    activityPostDialog (val) {
      if (!val) {
        this.usePic = []
        this.filesStore = null
        this.editId = -1
        this.title = ''
        this.outsideUrl = ''
        this.postContentMd = ''
        this.voucherTypeId = null
        this.visibleAt = null
      }
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    showLikeList () {
      console.log('3')
    },
    deletePic (index) {
      this.usePic.splice(index, 1)
    },
    async changActiveStatus (item) {
      item.active = !item.active
      await BLPost.edit(item)
      await this.reload()
    },
    async reload () {
      this.loading = true
      this.allActivityList = await BLPost.getList(true)
      this.voucherTypesList = this.voucherTypesList.concat(await getVoucherTypesList())
      this.allActivityList.sort(this.dateCompare('createTimestamp'))
      this.loading = false
    },
    dateCompare (dateKey) {
      return function (a, b) {
        return Date.parse(b[dateKey]) - Date.parse(a[dateKey])
      }
    },
    async deleteActivity (item) {
      await BLPost.remove(item.id)
      showSuccessMessage('delete_success')
      await this.reload()
    },
    async editActivity (item) {
      this.editObj = item
      this.title = item.title
      this.outsideUrl = item.outsideUrl
      this.postContentMd = item.postContentMd
      this.voucherTypeId = item.voucherTypeId
      this.usePic = item.images
      this.visibleAt = item.visibleAt
      this.editId = item.id
      this.activityPostDialog = true
    },
    async createNewPost () {
      this.btnLoading = true
      if (this.editId === -1) {
        await BLPost.add({
          images: await saveFilesWithArr(this.usePic),
          title: this.title,
          outsideUrl: this.outsideUrl,
          postContentMd: this.postContentMd,
          voucherTypeId: this.voucherTypeId,
          visibleAt: this.visibleAt
        })
      } else {
        this.editObj.images = await saveFilesWithArr(this.usePic)
        this.editObj.title = this.title
        this.editObj.outsideUrl = this.outsideUrl
        this.editObj.postContentMd = this.postContentMd
        this.editObj.voucherTypeId = this.voucherTypeId
        this.editObj.visibleAt = this.visibleAt
        await BLPost.edit(this.editObj)
      }
      this.btnLoading = false
      this.activityPostDialog = false
      showSuccessMessage('SuccessfullyPosted')
      await this.reload()
    }
  }
}
</script>

<style scoped>

</style>
